import { Box, Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import FunctionsIcon from "@material-ui/icons/Functions";

import { useReportGridStyles } from "../../../utils/report-layout";
import RoyaltyReportPanel from "./royalty-report-panel";
import RoyaltyMethodPanel from "./royalty-method-panel";

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  icon: {
    color: theme.palette.primary.main,
    display: "flex",
  },
  intro: {
    marginBottom: theme.spacing(2),
  },
}));

/**
 * The royalty tab. Royalty carries more than a report form — the partner terms, the
 * CPI-adjusted floor, which tickets settle and which are skipped, and what happens to
 * the ones nobody has priced. It sits apart from the templated reports so the method can
 * be read beside the run that used it.
 */
const RoyaltyReportView = () => {
  const classes = useStyles();
  const grid = useReportGridStyles();

  return (
    <Box className={grid.root}>
      <Grid container spacing={3} alignItems="flex-start">
        <Grid item xs={12} md={6}>
          <Paper elevation={3} className={classes.panel}>
            <Typography variant="h5" gutterBottom className={classes.title}>
              <span className={classes.icon}>
                <AccountBalanceIcon />
              </span>
              Generate Royalty Report
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.intro}
            >
              Royalty owed to a partner for a period, built from the tickets that
              were actually written up. Generating opens a summary of what settled,
              what was skipped and what was inferred, and emails the workbook.
            </Typography>
            <RoyaltyReportPanel />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} className={classes.panel}>
            <Typography variant="h5" gutterBottom className={classes.title}>
              <span className={classes.icon}>
                <FunctionsIcon />
              </span>
              How Royalty Is Calculated
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              className={classes.intro}
            >
              The formulas behind the report with this portal&apos;s configuration
              filled in, a worked example you can drive, and what each term on the
              report means.
            </Typography>
            <RoyaltyMethodPanel />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RoyaltyReportView;
